@if (pages.length > 0) {
    <div class="row float-right">
        <div class="col">
            <nav>
                <ul class="pagination {{ brand }}">
                    <li class="page-item" (click)="paginate(paginator.currentSelectedPage - 1)">
                        <a class="page-link pointer">
                            <span aria-hidden="true">&laquo;</span>
                        </a>
                    </li>
                    @for (page of pages | keyvalue; track page) {
                        <li class="page-item" [ngClass]="{'active': paginator.currentSelectedPage == page.value}">
                            <a class="page-link pointer" (click)="paginate(page.value)">{{ page.value }}</a>
                        </li>
                    }
                    <li class="page-item" (click)="paginate(paginator.currentSelectedPage + 1)">
                        <a class="page-link pointer">
                            <span aria-hidden="true">&raquo;</span>
                        </a>
                    </li>
                </ul>
            </nav>
        </div>
        <div class="col hide-in-responsive">
            <div class="form-group">
                <select name="items" (change)="setItemsPerPage($event)">
                    <option value="5">5</option>
                    <option value="10">10</option>
                    <option value="15">15</option>
                    <option value="20">20</option>
                </select>
            </div>
        </div>
    </div>
}
